export const SIZE_5MB = 5.24288e6;
export const SIZE_25MB = 25e6;
export const SIZE_50MB = 5.0e7;
